<template>
  <div>
    <DeleteProductModal
      :product-id="packageId"
      :deleting="deleting"
      v-on="{ submit: handleProductDelete }"
    />
  </div>
</template>

<script>
import { productMethods } from '@/store/adminHelper';
import DeleteProductModal from '@/components/Products/DeleteProductModal.vue';

export default {
  name: 'PackageDestroy',
  components: {
    DeleteProductModal,
  },
  props: {
    packageId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    deleting: false,
  }),
  methods: {
    ...productMethods,
    handleProductDelete(packageId) {
      this.deleting = true;
      this.deleteProduct({ productId: packageId })
        .then(() => {
          this.deleting = false;
          this.redirectToPackageList();
        })
        .catch(() => {
          this.deleting = false;
        });
    },
    redirectToPackageList() {
      this.$router.replace({ name: 'admin.products.packages' });
    },
  },
};
</script>
